import { EnvironmentType, type PlatformEnvironmentConfiguration } from './environment.interface';

/**
 * Base environment
 */
export const baseEnvironment: PlatformEnvironmentConfiguration = {
  // Fail-safe default: an environment file that forgets to override this is treated as production,
  // so it never surfaces a development/staging notice in a production build.
  environmentType: EnvironmentType.Production,
  serviceWorker: true,
  baseTitle: 'CtrlChain',
  enableHubspot: true,
  // set preview flag here, it should be applied to default and preview environments, other environments explicity override it to be undefined
  previewFlag: undefined,
  googleKey: '',
  // Cloudflare's "always passes, invisible" testing sitekey — see
  // https://developers.cloudflare.com/turnstile/troubleshooting/testing/
  //
  // The default has to be a testing key because E2E runs headless, and a real widget never issues
  // a token to an automated browser: the challenge simply never resolves and the login button stays
  // disabled. Environments that need genuine protection (staging, production) override this with
  // their own Cloudflare widget, and their key vault holds the matching real secret.
  turnstileSiteKey: '1x00000000000000000000BB',
  transloco: {
    includeTestLanguage: true,

    missingHandler: {
      logMissingKey: true,
    },
    cache: {
      // 7 * 24 * 60 * 60 * 1000 = 1 week
      shortLifetime: 604_800_000,

      // 6 * 7 * 24 * 60 * 60 * 10000 = 6 weeks
      longLifetime: 36_288_000_000,
    },
  },
  security: {
    defaultTrustedTypesPolicy: true,
    routing: {
      preventPathTraversalParams: true,
      checkIdParams: true,
      checkReferenceParams: true,
    },
  },
  features: {
    showTrackingSimulation: true,
    showEmailSimulation: true,
    // Fail-safe: where an environment does not say it runs EmailService, its calls would hit the SPA's nginx.
    showEmailService: false,
    authentication: {
      urlAfterLogin: '/',
      urlAfterLogout: '/authentication',
      excludedReturnUrls: ['/page-not-found', '/page-not-accessible', '/page-not-permitted'],
    },
    logger: {
      logSuccessFullReportsToConsole: true,
      reportError: false,
    },
  },
  msalConfig: {
    auth: {
      clientID: 'b8d05b1e-4764-407a-9ed2-677243ee621c',
      authority: 'https://login.microsoftonline.com/85ffde86-f494-4a60-a93e-f957c8d672ed',
    },
    apiConfig: {
      scopes: ['user.read', 'mailboxsettings.read'],
      uri: 'https://graph.microsoft.com/v1.0',
    },
  },
};
